import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
import { invoicesActionCreators } from '../../data/invoices/invoicesAction';
import { ApiInvoicesState } from '../../data/invoices/invoicesModels';
// tslint:disable-next-line:no-var-requires
const invoices = require('../../resources/invoices.png');
import * as moment from 'moment';
import * as FontAwesome from 'react-fontawesome';
import { connect, Dispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import Table from '../../components/table/table';
import { DataType, RowObject, Tbody } from '../../components/table/tableModels';
import * as Client from '../../data/apiClient/client';
import { orderActionCreators } from '../../data/order/orderActions';
import { ApiOrderObject, ApiOrderState } from '../../data/order/orderModels';

// tslint:disable-next-line:no-var-requires
const html2pdf = require('html2pdf.js');

/* tslint:disable */
type OrderProps = OrderState & // ... state we've requested from the Redux store
    OrderActions & // ... plus action creators we've requested
    RouteComponentProps<{ id: string }>;

interface OrderState {
    header: HeaderState;
    invoices: ApiInvoicesState;
    orders: ApiOrderState;
}

interface OrderActions {
    headerActions: typeof headerActionCreators;
    invoicesActions: typeof invoicesActionCreators;
    orderActions: typeof orderActionCreators;
}

interface State {
    order: ApiOrderObject | undefined;
    id: string | undefined;
    tHead: Array<RowObject>;
}

class Order extends React.Component<OrderProps, State> {
    constructor(props: OrderProps) {
        super(props);
        this.state = {
            tHead: [
                new RowObject(DataType.string, 'Line Number', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Item Number', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Description', undefined, undefined, 'pointer')
            ],
            order: undefined,
            id: undefined
        };
        this.getTheOrder = this.getTheOrder.bind(this);
        this.renderTheBody = this.renderTheBody.bind(this);
        this.saveOrderAsPdf = this.saveOrderAsPdf.bind(this);
    }

    getTheOrder(id: string) {
        let ordersClient = new Client.OrdersClient();
        if (id !== this.state.id) {
            ordersClient.get(id).then((res) => {
                this.setState({
                    id: id,
                    order: new ApiOrderObject(res)
                });
            });
        }
    }

    saveOrderAsPdf() {
        let logoHtml = document.getElementsByClassName('headerLogoPadding');
        let htmlData = document.getElementById('orderdata');
        if (htmlData !== undefined && htmlData !== null) {
            var order = this.state.order;
            if (
                logoHtml !== undefined &&
                logoHtml !== null &&
                htmlData !== undefined &&
                htmlData !== null &&
                htmlData.firstChild !== null &&
                order !== undefined
            ) {
                var opt = {
                    margin: 5,
                    pagebreak: { mode: 'avoid-all' },
                    filename: 'Order_' + order.orderNumber + '.pdf',
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 5 },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
                };
                let html = logoHtml[0].outerHTML + '<br><br><br><br><br><br><br>' + htmlData.outerHTML;
                html2pdf().set(opt).from(html).save();
            }
        } else {
            alert('Error');
        }
    }

    renderTheBody() {
        if (this.state.order !== undefined && this.state.order.orderRows) {
            return this.state.order.orderRows.map((obj) => {
                let rBody = new Array<RowObject>();

                rBody.push(
                    new RowObject(DataType.string, obj.lineNumber ? obj.lineNumber : '', null, undefined, undefined)
                );

                rBody.push(
                    new RowObject(DataType.string, obj.itemNumber ? obj.itemNumber : '', null, undefined, undefined)
                );

                rBody.push(
                    new RowObject(DataType.string, obj.description ? obj.description : '', null, undefined, undefined)
                );

                return new Tbody(rBody);
            });
        } else {
            let rBody = new Array<RowObject>();
            rBody.push(new RowObject(DataType.string, '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, '', null, undefined, undefined));

            return [new Tbody(rBody)];
        }
    }

    componentWillMount() {
        this.getTheOrder(this.props.match.params.id);
    }

    public render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="componentHeader">
                        <div className="item tile">
                            <div className="tileHead">
                                <div className="float-left">
                                    <h4>{'Order'}</h4>
                                </div>
                                <div className="tileImage float-right">{<img src={invoices} />}</div>
                            </div>
                            <div className="tileBody">
                                <div className="topBorder" />
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    className="btn pdf-btn float-right"
                    onClick={this.saveOrderAsPdf}
                    disabled={this.state.order == undefined}
                    id="pdf-btn"
                >
                    <i className="fa fa-file-pdf-o fa-2x" />
                </button>
                {this.state.order !== undefined ? (
                    <div className="row" id="orderdata">
                        <div className="col-sm-12">
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="bold">Order Number:</div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div>
                                                {this.state.order.orderNumber ? this.state.order.orderNumber : ''}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="bold">Customer Account:</div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div>{this.state.order.customer ? this.state.order.customer : ''}</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="bold">Territory:</div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div>{this.state.order.territory ? this.state.order.territory : ''}</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="bold">Order Reference:</div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div>
                                                {this.state.order.orderReference ? this.state.order.orderReference : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="bold">Order Date:</div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div>
                                                {this.state.order.orderDate
                                                    ? moment(this.state.order.orderDate, 'M/D/YYYY').format('M/D/YYYY')
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="bold">Purchase Order:</div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div>
                                                {this.state.order.purchaseOrder ? this.state.order.purchaseOrder : ''}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="bold">Customer:</div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div>{this.state.order.customer ? this.state.order.customer : ''}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="bold">Shipping Information</div>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="bold">Name:</div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div>
                                                        {this.state.order.shippingName
                                                            ? this.state.order.shippingName
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="bold">Adress:</div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div>
                                                        {this.state.order.shippingAddress
                                                            ? this.state.order.shippingAddress
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="bold">City:</div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div>
                                                        {this.state.order.shippingCity
                                                            ? this.state.order.shippingCity
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="bold">State:</div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div>
                                                        {this.state.order.shippingState
                                                            ? this.state.order.shippingState
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="bold">Postal Code:</div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div>
                                                        {this.state.order.shippingPostalCode
                                                            ? this.state.order.shippingPostalCode
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="bold">Phone:</div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div>
                                                        {this.state.order.shippingPhone
                                                            ? this.state.order.shippingPhone
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="bold">Fax:</div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div>
                                                        {this.state.order.shippingFax
                                                            ? this.state.order.shippingFax
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="bold">Estimated Ship Date:</div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div>
                                                    {this.state.order.estimatedShipDate
                                                    ? moment(this.state.order.estimatedShipDate, 'M/D/YYYY').format('M/D/YYYY')
                                                    : ''}                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row topMargin">
                                <div className="col-sm-12">
                                    {this.state.order.orderRows ? (
                                        <Table
                                            tHead={this.state.tHead}
                                            tBody={this.renderTheBody()}
                                            listSize={this.state.order.orderRows.length}
                                            hover={true}
                                            cursor={true}
                                            hidePagination={true}
                                            americanDateFormat={true}
                                        />
                                    ) : (
                                        <div>No Order Row Data.</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="centerThis">
                        <FontAwesome className="progressicon" name="spinner" size="3x" spin={true} />
                    </div>
                )}
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): OrderState {
    return {
        header: state.header,
        invoices: state.invoices,
        orders: state.order
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): OrderActions {
    return {
        headerActions: bindActionCreators(headerActionCreators, dispatch),
        invoicesActions: bindActionCreators(invoicesActionCreators, dispatch),
        orderActions: bindActionCreators(orderActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(Order)
);



// WEBPACK FOOTER //
// ./src/containers/order/order.tsx